//import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import '@fancyapps/fancybox';

function FancyBox() {

  $().fancybox({});
  
}

export default FancyBox;